module.exports = __webpack_public_path__ + "static/top50-f61a12dca6fef1465ad19d3060dac599.jpg";